(function () {

    a3_cabin_reports.directive('syllabusProgressReadOnly', syllabusProgressReadOnly);

       /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name syllabusReadOnly
   * @restrict E
   * @description
   *   Initialize read only view of submitted syllabus
   * @example
   *   Usage:
   *   <syllabus-progress-read-only></syllabus-progress-read-only>
   * @ngInject
   */

    function syllabusProgressReadOnly() {
        function link(scope) {
            scope.showRemarks = {
                value: false
            };
            scope.oneAtATime = true;
            scope.filterItems = filterItems;
            scope.toggleItems = toggleItems;

            setSyllabus(scope.history);

            function setSyllabus(history) {
                var traineeSessionItems = [];
                scope.phase.Syllabus.SyllabusItems.forEach(function (item) {
                    
                    var syllabusItem = JSON.parse(JSON.stringify(item));
                    syllabusItem.Tries = [];
                    syllabusItem.Selected = false;

                    var relatedSessionItem = history.SyllabusProgress.find(x => x.SyllabusItemId == syllabusItem.Id);
                    
                    if(relatedSessionItem){
                        syllabusItem.hasRemarks = relatedSessionItem.Tries.some(x => x.Comments && x.Comments.length>0) ||
                                                  relatedSessionItem.Tries.some(t=> t.TryGrading.Competences.some(x => x.Comments && x.Comments.length>0));
                        syllabusItem.Selected = true;
                        syllabusItem.Tries = relatedSessionItem.Tries;
                        syllabusItem.Tries.forEach(function(attempt){
                            attempt.Selected = true;
                        });
                    }

                    setPanelStyle(syllabusItem); 
                    traineeSessionItems.push(syllabusItem);
                });

                history.ItemsGrouped = SyllabusGrouping(traineeSessionItems);
            }

            
            function setPanelStyle(item){
                var historyTriesCount = item.Tries.filter(x => x.isReadOnly).length;
                var newTriesCount = item.Tries.filter(x => !x.isReadOnly && x.Selected).length;
                item.TriesPerformedCount = historyTriesCount + newTriesCount;

                var completedItem = item.TriesPerformedCount >= item.MandatoryCount;

                if(item.MandatoryCount == 0){   //non-mandatory items are considered completed if performed at least once
                    completedItem = item.TriesPerformedCount>=1;
                }

                if(completedItem){
                    item.PanelClass = 'panel-green panel-border-left-green ';
                }
                else{
                    item.PanelClass = 'panel-border-left-blue ';
                }
            }

            function SyllabusGrouping(items) {
                //Syllabus Items Group By 'GroupId'
                var syllabusGroups = [];
                items.forEach(function (item) {
                    if (!syllabusGroups.some(x => x.Id == item.SelectedGroup.Id)) {
                        if (!item.SelectedGroup) {
                            item.SelectedGroup = {
                                Id: 0,
                                Title: 'General'
                            };
                        }

                        var syllabusGroup = {
                            Id: item.SelectedGroup.Id,
                            Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
                            Items: []
                        };

                        syllabusGroup.Items.push(item);
                        syllabusGroups.push(syllabusGroup);
                    }
                    else {
                        syllabusGroups.filter(x => x.Id == item.SelectedGroup.Id)[0].Items.push(item);
                    }
                });

                return syllabusGroups;
            }

            function filterItems(){
                return function( item ) {
                    var showItem = true;
                    if(scope.showRemarks.value){
                        showItem = item.hasRemarks;
                        
                    }
                    else{
                        scope.oneAtATime = true;
                    }
                    return showItem;
                };
            }

            function toggleItems(){
                scope.oneAtATime = !scope.showRemarks.value;
               
                scope.history.ItemsGrouped.forEach(function(syllabusGroup){
                    syllabusGroup.Items.forEach(function(item){
                        item.isOpen = scope.showRemarks.value;
                    });
                });
            }
        }
        return {
            restrict: 'E',
            templateUrl: 'views/TrainingReadOnly/syllabus-progress-read-only.tpl.html',
            scope : { phase:"=", history:"="},
            terminal: true,
            link: link
        }
    }
})();